import React from "react";
import { useNavigate } from "react-router-dom";
import { clearDB } from "../utils/ImageDB";
import { logout, getToken } from "../utils/auth";

const Navbar = ({ projectName }) => {
  const navigate = useNavigate();
  const isLoggedIn = !!getToken(); // Check if user is authenticated

  const handleClearDB = async () => {
    await clearDB();
    alert("DB CLEARED");
    navigate('/add-project');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-gradient-to-r z-50 h-14 from-indigo-900 to-purple-800 fixed w-full top-0 backdrop-blur-sm bg-opacity-90 border-b border-indigo-300/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
              <img
                src="/logo-sq.png"
                alt="Logo"
                className="w-6 h-6 object-contain"
              />
            </div>
            <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-300 to-blue-200 tracking-tight">
              IMAGE LABELER
            </span>
            <span className="text-sm bg-clip-text text-transparent bg-gradient-to-r from-cyan-300 to-blue-200 tracking-tight">
              by Orama Solutions
            </span>
            {projectName && (
              <span className="text-lg font-semibold text-gray-200 tracking-tight bg-clip-text capitalize">
                {projectName || ""} Project
              </span>
            )}
          </div>

          <div className="flex items-center space-x-4">
            {isLoggedIn && (
              <button
                onClick={handleClearDB}
                className="relative group flex items-center space-x-1 bg-transparent hover:bg-red-500/10 px-4 py-2 rounded-lg transition-all duration-300 border border-red-400/30"
              >
                <span className="text-red-300 group-hover:text-red-100 font-medium text-sm tracking-wide transition-colors">
                  CLEAR PROJECT
                </span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-red-400 group-hover:text-red-200 transition-colors"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </div>
                <span className="absolute -bottom-1 -left-1 w-0 h-0.5 bg-red-400 group-hover:w-full transition-all duration-300"></span>
              </button>
            )}

            {isLoggedIn ? (
              <button
                onClick={handleLogout}
                className="relative group flex items-center space-x-1 bg-transparent hover:bg-indigo-500/10 px-4 py-2 rounded-lg transition-all duration-300 border border-indigo-400/30"
              >
                <span className="text-indigo-300 group-hover:text-indigo-100 font-medium text-sm tracking-wide transition-colors">
                  LOGOUT
                </span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-indigo-400 group-hover:text-indigo-200 transition-colors"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                </div>
              </button>
            ) : (
              <button
                onClick={handleLogin}
                className="relative group flex items-center space-x-1 bg-transparent hover:bg-indigo-500/10 px-4 py-2 rounded-lg transition-all duration-300 border border-indigo-400/30"
              >
                <span className="text-indigo-300 group-hover:text-indigo-100 font-medium text-sm tracking-wide transition-colors">
                  LOGIN
                </span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-indigo-400 group-hover:text-indigo-200 transition-colors"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                    />
                  </svg>
                </div>
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;